import styled from "@emotion/styled";
import theme from "../../styles/theme";
import Link from "../../components/link/link";

export const NestedContentBase = styled.div``;

export const NestedContentContainer = styled.div`
  max-width: ${theme.narrowWidth};

  &.wide {
    max-width: ${theme.maxWidth};
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1px solid #d8dee1;

  &.center-align-text {
    text-align: center;

    h2 {
      max-width: 700px;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const Title = styled.h2`
  color: ${theme.colors.darkBlues[100]};
`;

export const TitleLink = styled(Link)``;
